module.exports = __webpack_public_path__ + "img/4.a800f758.jpg";